<template>
  <div class="content bg8">
      <div class="explore-programs-dropdown" style="text-align:center;padding:24px 16px 18px 16px;background:#fff;border-radius:12px;box-shadow:0 2px 8px 0 rgba(191,0,255,0.04);">
        <label for="program-select" class="dropdown-label" style="font-weight:600;color:#7a4fa3;font-size:1.1rem;margin-bottom:10px;display:block;">Explore Internship Programs</label>
        <select id="program-select" class="program-select" @change="onProgramChange" :value="$route.path">
          <option value="/digital-marketing-internship">Digital Marketing</option>
          <option value="/social-media-marketing-internship">Social Media Marketing</option>
          <option value="/content-creation-internship">Content Creation and Copywriting</option>
          <option value="/website-design-internship">Website Design</option>
          <option value="/data-analytics-internship">Data Analytics and BI</option>
          <option value="/graphic-design-internship">Graphic Design</option>
        </select>
      </div>
      <div class="middled">
        <div class="button-row">
          <a href="https://forms.gle/sgqWzHuRMRCzCV6q6" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Company Application</button>
          </a>
          <a href="https://forms.gle/gv7FWmgVsKKPBfhX7" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Intern Application</button>
          </a>
        </div>
      <div class="basehero">
        <h1>Website Design &amp; Management Internship Program</h1>
        <h2 class="section">Build a Smarter Web Presence. Learn by Doing.</h2>

        <p>
          <strong>Foclarity’s Website Design &amp; Management Internship Program</strong> pairs startups with student talent ready to create high-impact websites and manage them for real business results. Interns gain hands-on skills in web design, UX, site updates, and content management, while startups get practical, polished improvements to their online presence.
        </p>

        <h3>For Startups:</h3>
        <p>
          Whether you’re building your first site or need ongoing updates and improvements, we give you a skilled team of interns who can execute quickly and professionally. 
        </p>
        <ul>
          <li>Custom website design and front-end improvements</li>
          <li>Content updates, page creation, and site maintenance</li>
          <li>Performance monitoring and analytics integration</li>
          <li>UX/UI enhancements to improve engagement and conversion</li>
          <li>Collaboration with your team to keep your site fresh and effective</li>
        </ul>
        <p>
          You’ll receive regular updates, guided oversight from marketing and design professionals, and a website that works as hard as you do.
        </p>

        <h3>For Interns:</h3>
        <p>
          Go beyond theory and work on real websites that generate traffic, leads, and revenue. You’ll collaborate directly with startups and mentors to deliver visible results and build your professional toolkit.
        </p>
        <ul>
          <li>Learn front-end design with tools like Webflow, WordPress, or Figma</li>
          <li>Practice content management, page building, and site updates</li>
          <li>Monitor site performance and user experience</li>
          <li>Use Google Analytics, Search Console, and Tag Manager</li>
          <li>Understand UX principles and apply them in live projects</li>
        </ul>
        <p>
          You’ll finish with a portfolio of real work—and skills that employers are hiring for right now.
        </p>

        <h3>Ready to Get Started?</h3>
        <p>
          Whether you're a founder ready to level up your website or a student eager to learn by building real things, this program is your launchpad.
        </p>

        <div class="button-row">
          <a href="https://forms.gle/sgqWzHuRMRCzCV6q6" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Company Application</button>
          </a>
          <a href="https://forms.gle/gv7FWmgVsKKPBfhX7" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Intern Application</button>
          </a>
        </div>
      </div>
      <div class="explore-programs" style="text-align:center;padding:32px 16px 24px 16px;background:#f7f2fa;border-radius:12px;box-shadow:0 2px 8px 0 rgba(191,0,255,0.04);">
        <h2 style="color:#7a4fa3;font-size:1.3rem;margin-bottom:16px;">Explore More Internship Programs</h2>
        <ul class="explore-list" style="list-style:none;padding:0;margin:0;">
          <li style="margin:10px 0;"><router-link to="/digital-marketing-internship" class="subnav-link">Digital Marketing</router-link></li>
          <li style="margin:10px 0;"><router-link to="/social-media-marketing-internship" class="subnav-link">Social Media Marketing</router-link></li>
          <li style="margin:10px 0;"><router-link to="/content-creation-internship" class="subnav-link">Content Creation and Copywriting</router-link></li>
          <li style="margin:10px 0;"><router-link to="/website-design-internship" class="subnav-link">Website Design</router-link></li>
          <li style="margin:10px 0;"><router-link to="/data-analytics-internship" class="subnav-link">Data Analytics and BI</router-link></li>
          <li style="margin:10px 0;"><router-link to="/graphic-design-internship" class="subnav-link">Graphic Design</router-link></li>
        </ul>
        <div style="margin-top:18px;">
          <router-link to="/who-we-serve" class="subnav-link" style="font-size:1.05em;">Back to All Programs</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WebsiteDesignInternship",
  methods: {
    onProgramChange(event) {
      const path = event.target.value;
      if (path && path !== this.$route.path) {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style scoped>
.subnav-link {
  margin: 0 10px;
  color: #BF00FF;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}
.subnav-link:hover {
  color: #7a4fa3;
  text-decoration: underline;
}
.subnav-link.router-link-exact-active {
  text-decoration: underline;
  font-weight: bold;
}
.explore-programs-dropdown {
  margin: 40px auto 0 auto;
  max-width: 600px;
  text-align: center;
  padding: 24px 16px 18px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px 0 rgba(191,0,255,0.04);
}
.dropdown-label {
  font-weight: 600;
  color: #7a4fa3;
  font-size: 1.1rem;
  margin-bottom: 10px;
  display: block;
}
.program-select {
  width: 100%;
  max-width: 420px;
  padding: 12px 16px;
  font-size: 1.08rem;
  border: 1.5px solid #BF00FF;
  border-radius: 8px;
  background: #f7f2fa;
  color: #41037b;
  font-weight: 500;
  outline: none;
  transition: border 0.2s;
  margin: 0 auto;
  box-shadow: 0 1px 4px 0 rgba(122,79,163,0.04);
}
.program-select:focus {
  border: 2px solid #7a4fa3;
}
@media (max-width: 600px) {
  .explore-programs-dropdown {
    padding: 16px 4px 12px 4px;
  }
  .program-select {
    font-size: 1em;
    padding: 10px 8px;
    max-width: 100%;
  }
}
</style>
